import React, { useState, useEffect } from 'react'

const TestimonialsEnterprise = ({ block }) => {
  const [active, setActive] = useState(0)
  const countTestimonials = block.testimonials.length
  
  let animationInterval

  const toggleMilestones = e => {
    const index = parseInt(e.target.id, 0);
    if (index !== active) {
      setActive(index)
    }
  };

  const startAnimation = () => {
    animationInterval = setInterval(() => {
      setActive(active + 1 >= countTestimonials ? 0 : active + 1)
    }, 5000);
  }

  const pauseAnimation = () => {
    clearInterval(animationInterval)
  }

  useEffect(() => {
    startAnimation()
    return () => clearInterval(animationInterval)
  }, [active]);

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className="container">
        <div className='milestones-wr' onMouseEnter={pauseAnimation} onMouseLeave={startAnimation}>
          {block.testimonials.map((item, index) => {
            return <div key={index} className={`row milestone ${active === index ? 'is-active' : ''}`} active={`${active === index}`}>
              <div className='col-lg-10 offset-lg-1'>
                <div className='content-wr'>
                  {item.image_logo && (
                    <img className='img-logo' src={item.image_logo} alt={item.name}  title={item.name} loading="lazy" />
                  )}

                  {item.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: item.text}}></div> )}
                  <div className='author'>
                    {item.image_person && (
                      <img className='img-person' src={item.image_person} alt={item.name}  title={item.name} loading="lazy" />
                    )}
                    <div className='right'>
                      {item.name && ( <div className="name" dangerouslySetInnerHTML={{__html: item.name}}></div> )}
                      {item.company && ( <div className="company" dangerouslySetInnerHTML={{__html: item.company}}></div> )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
        <div className='timeline-wr'>
          <ul className='dates'>
            {block.testimonials.map((item, index) => {
              return <li key={index} className={`${active === index ? 'is-active' : ''}`} onClick={toggleMilestones} active={`${active === index}`} id={index}>
              </li>
            })}
          </ul>
        </div>
      </div>
    </section>
  )

}

export default TestimonialsEnterprise
